import React from 'react';

import { gql } from '@apollo/client';
import { assertIsoDateTimeRange } from '@modernloop/shared/datetime';

import { ActivityLogInterviewerRsvpDeclined_ActivityLogFragment, ResponseStatus } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

import { ProposedTimeContent } from '../shared/InterviewerRsvp/ProposedTimeContent';

interface Fragments {
  activityLog: ActivityLogInterviewerRsvpDeclined_ActivityLogFragment;
}

const ActivityLogTaskInterviewerRsvpDeclined: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;
  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogInterviewerRsvpDeclinedDetails') {
    throw new Error(
      'ActivityLogInterviewerRsvpDeclinedDetails: details is not ActivityLogInterviewerRsvpDeclinedDetails'
    );
  }
  const { interviewName, comment, proposedTime } = details;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      responseStatus={ResponseStatus.Declined}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.declinedInterview"
      actionLabelValues={{ interviewName }}
    >
      {comment ? <ActivityLogContent content={comment} /> : null}
      {proposedTime ? <ProposedTimeContent proposedTime={assertIsoDateTimeRange(proposedTime)} /> : null}
    </ActivityLogBase>
  );
};

ActivityLogTaskInterviewerRsvpDeclined.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogInterviewerRsvpDeclined_activityLog on ActivityLog {
      id
      details {
        __typename
        ... on ActivityLogInterviewerRsvpDeclinedDetails {
          __typename
          interviewName
          comment
          proposedTime {
            startAt
            endAt
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskInterviewerRsvpDeclined;
